import React from 'react';
import { useTrackingContext } from '../context/trackingContext';

const Footer = () => {
  const { trackClick } = useTrackingContext();
  return (
    <div className="sticky flex justify-center mb-4">
      <div className="flex max-w-[1200px] flex-row px-6 flex-wrap sm:justify-evenly gap-x-3 uppercase text-xs sm:text-sm text-gray">
        <p>© {new Date().getFullYear()} Build A Rocket Boy</p>
        <a
          className="hover:underline"
          onClick={() => trackClick({ btnName: 'Footer: terms of use' })}
          href="https://www.buildarocketboy.com/terms-of-use"
          target="blank">
          TERMS OF USE
        </a>
        <a
          className="hover:underline"
          onClick={() => trackClick({ btnName: 'Footer: privacy policy' })}
          href="https://www.buildarocketboy.com/privacy-notice"
          target="blank">
          PRIVACY NOTICE
        </a>
      </div>
    </div>
  );
};

export default Footer;
